import React, { PureComponent, Fragment, memo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { toDDHHMMSS } from '../../../components/Util/Util.js'

class detalleATiempoSuc extends PureComponent {

    render() {
        const{listTiempos, suc} = this.props;
        const tiempo= listTiempos.filter((item) => item.Suc_Id == suc); 
        let NombreSuc = ''; 
        if (tiempo.length > 0) {
             NombreSuc = tiempo[0].Suc_Nombre;            
        return (
            <Fragment>
                <tr className = "sucursal-tiempos">
                 <td colspan="6" className="text-center">{NombreSuc}</td>          
                
                </tr>
                {
                    tiempo.map((tiem, index) => {
                        
                         if(tiem.Orden_Lista == 5)  {
                        return ( <tr key={index}>
                            <td className= "font-weight-bold">{tiem.Estatus}</td>
                            <td className= "font-weight-bold">{tiem.EntroTxt}</td>
                            <td className= "font-weight-bold">{tiem.SalioTxt}</td>
                            <td className= "font-weight-bold">{toDDHHMMSS(tiem.DuracionTS)}</td>
                            <td className= "font-weight-bold">{toDDHHMMSS(tiem.DesignadoTS)}</td>
                            <td className= "font-weight-bold"> {`${tiem.RetrasoStr == 'SI' ? '-' :  '+' } ${toDDHHMMSS(tiem.RetrasoTS).join('')}`}</td>                            
                            </tr>)
                         }else{
                             return(<tr key={index}>
                            <td >{tiem.Estatus}</td>
                            <td>{tiem.EntroTxt}</td>
                            <td>{tiem.SalioTxt}</td>
                            <td>{toDDHHMMSS(tiem.DuracionTS)}</td>
                            <td>{toDDHHMMSS(tiem.DesignadoTS)}</td>
                            <td> {`${tiem.RetrasoStr == 'SI' ? '-' :  '+' } ${toDDHHMMSS(tiem.RetrasoTS).join('')}`}</td>  
                            </tr>)
                         }
                        
                    })
                }
            </Fragment>
        )
        }else{
            return (
            <Fragment> </Fragment>
            )

        }
    }

}
const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        usuarioLogueado: state.usuario.usuarioLogueado,
        empresa: state.parametros.empresa,
        sucursal: state.parametros.sucursal,
        callCenter: state.parametros.callCenter
    };
};
export default connect(mapStateToProps)(withRouter(memo(detalleATiempoSuc)));
